export const enum CookieKeys {
  REGION_ID = 'etg_rid',
  HAS_SMART_BANNER_CLOSED = 'hasSmartBannerClosed',
}

export const enum QueryStringKeys {
  SLOT = 'slot',
  REDIRECT_URL = 'ru',
  LIST_PAGE = 'page',
  SEARCH_FILTER = 'filter',
  SCROLL_TO_REVIEWS_SECTION = 'strs',
  SEARCH_KEYWORD = 'keyword',
  NO_SHOW_REPLY_TOKEN = 'reply_token',
  CS_CHAT = 'cs_chat',
  PROMO_CODE = 'code',
  PROMO_AUTO_REDEEM = 'redeem',
  SUGGESTION_CONTEXT = 'keyword_context',
}

export const enum StorageKeys {
  DEVICE_ID = 'device-id',
  FIRST_TIME_PURCHASE = 'first-time-purchase',
  SMS_VALIDATION_EXPIRED_AT = 'sms-validation-expired-at',
  SEARCH_RECORDS = 'search-records',
  LAST_PAYMENT_GATEWAY = 'last-payment-gateway',
  SITE_ID = 'site-id',
}

export const enum TrackingAuthType {
  EMAIL = 'email',
  FB = 'fb',
  // Below are unused
  APPLE = 'apple',
  GOOGLE = 'google',
}

export const KB = 1024
export const MB = KB * 1024

export const DEFAULT_RESTAURANT_ATTENDANCE = 2
export const DEFAULT_REVIEW_TAG_ID = -1
export const ALL_SUB_CATEGORY_ID = 0
export const REVIEW_CARD_ID_PREFIX = 'review-card'
export const DEFAULT_MAX_FILE_UPLOAD_SIZE = 5 * MB

export const PROMO_CODE_DEFAULT_ID = 0
export const PROMO_CODE_UNSELECTED_ID = -1

export const DEFAULT_DEBOUNCE = 500
export const FORM_VALIDATION_DEBOUNCE = 500

export const SEARCH_HIGHLIGHT_KEY = 'search-highlight'

export const PROMO_CODE_LIMIT_MIN_PAX = 2
